module.exports = __webpack_public_path__ + "img/warning-circle.692e67a8.svg";